// extracted by mini-css-extract-plugin
module.exports = {"category-name":"list_category-name__2E6KD","header":"list_header__dynoK","heading":"list_heading__JWyYh"};